import { ContractAction } from 'ggApp/types/graphql';
import mergeArrayValuesByField from '../../utils/mergeCacheHelpers/mergeArrayValuesByField';

const BasicContractTypePolicy = {
    type: 'BasicContract',
    policy: {
        fields: {
            billingTerms: {
                merge: true,
            },
            actions: {
                merge: mergeArrayValuesByField<ContractAction>('__typename'),
            },
        },
    },
};

export default BasicContractTypePolicy;
